import * as bootstrap from 'bootstrap'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import Lenis from '@studio-freight/lenis';

import Common from "./Common";

import PageAbout from "./pages/PageAbout";
import PageAwards from "./pages/PageAwards";


gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

window.addEventListener("load", () => {
    const lenis = new Lenis({
        smooth: true,
    });

    // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
    // This allows GSAP to control the scroll position and trigger animations based on scroll events    
    // lenis.on('scroll', ScrollTrigger.update);

    // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
    // This ensures Lenis's smooth scroll animation updates on each GSAP tick
    gsap.ticker.add((time) => {
        lenis.raf(time * 1000); // Convert time from seconds to milliseconds
    });

    // Disable lag smoothing in GSAP to prevent any delay in scroll animations
    gsap.ticker.lagSmoothing(0);

    // function raf(time) {
    //     lenis.raf(time);
    //     requestAnimationFrame(raf);
    // }

    // requestAnimationFrame(raf);

    let common = new Common();
    common.init();
  
    init()

    // set scroll refresh always delay 500ms
    ScrollTrigger.refresh(true, 500);


    document.querySelector(".page").removeAttribute("loading");
});

const init = async () => {
    const pageAboutDOM = document.querySelector(".page#page-about");
    if (pageAboutDOM) {
        let pageAbout = new PageAbout(pageAboutDOM);
        await pageAbout.init();
    }

    const pageAwardsDOM = document.querySelector(".page#page-awards");
    if (pageAwardsDOM) {
        let pageAwards = new PageAwards(pageAwardsDOM);
        await pageAwards.init();
    }
}